import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-wire-green',
  templateUrl: './icon-wire-green.component.html',
  styles: []
})
export class IconWireGreenComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
